import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Table from 'views/security/totalContingencies/table'; // Importing Table component

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Retrieves the current theme from app config

        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applies the current theme as CSS class
                    elements: [
                        {
                            view: 'label', // Label component
                            label: _('Contigencias Totales'), // Localized label text
                            align: 'center', // Center alignment for the label
                        },
                    ],
                },
                Table, // Table component to be included in the layout
            ],
        };

        webix.ui.fullScreen(); // Sets the UI to full screen mode

        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the view
            view: 'form', // Form view type
            scroll: 'y', // Enables vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive design for the view
                    type: 'wide', // Wide type for the layout
                    cols: [left], // Columns layout containing the left section
                },
            ],
        };
    }
}

// FILE DOCUMENTED
